<template>
  <v-app>

    <navigation-bar/>
    <SuperiorMenu v-if="this.$route.path.includes('/secadero_') "> </SuperiorMenu>

    <v-main
      v-if="isMounted"
      :class="has_bottom_drawer ? '' : 'pb-0'"
    >

      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

import SuperiorMenu from "@/components/layout/SuperiorMenu.vue";
import NavigationBar from './components/NavigationBar.vue'

export default {
  name: "App",

  components: {
    SuperiorMenu,NavigationBar
  },

  data: () => ({
    isMounted: false,
  }),

  computed: {
    ...mapState(["selectedItem", "editing"]),
    ...mapGetters(["actualPage"]),

    has_bottom_drawer() {
      return this.editing && this.actualPage?.global_item_list?.length > 0;
    },
  },


  methods: {
    ...mapActions(["retrieveToken"]),
    ...mapActions('nodered',["createConnection"]),

  },

  async mounted() {
    await this.retrieveToken();
    this.isMounted = true;
    const topics = [
      "ensayos","PREVIOS","hornos","hornos_previo"
    ]
    this.createConnection(topics)
  },
};
</script>

<style scoped>
.logo-drawer {
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 15px;
  padding-bottom: 15px;
  justify-content: center;
}

.drawer-list-item {
  margin-bottom: 5px;
}
</style>
